'use client';
import dynamic from 'next/dynamic';
import { FormBlock as FormBlockType } from '@/payload-types';
import { BlockComponentProps } from '@/types/ContactMainContainerBlock';

/**
 * Frontiere de chargement paresseux pour FormBlock (react-hook-form,
 * @radix-ui/react-select, react-google-recaptcha, la liste des pays).
 *
 * L'`import()` doit partir d'un module CLIENT. Appele depuis un Server Component
 * — ce que faisait ContactMainContainerBlock — `dynamic()` cree bien un fichier
 * separe, mais le module reste dans le groupe de chunks initial de la page :
 * toutes les pages telechargeaient le formulaire. Voir le manifeste
 * `page_client-reference-manifest.js` pour verifier.
 */
const FormBlock = dynamic(() =>
  import('./FormBlock').then((m) => m.FormBlock),
);

export default function FormBlockLazy(props: BlockComponentProps) {
  return <FormBlock {...(props as FormBlockType)} />;
}
